import request from "./request";

export const _http = {
  //待上帐已上账数量
  getNum(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/record/getNum",
      data: params,
    });
  },
  //商户充值记录
  getList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/record/getList",
      data: params,
    });
  },
  //手动查询
  getQueryWeBack() {
    return request({
      method: "GET",
      url: "/platform/pc/account/record/getQueryWeBank",
    });
  },
  //导出
  excel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/record/excel",
      data: params,
      responseType: "blob",
    });
  },
  //上账至回收商
  upMerchant(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/record/up-merchant",
      data: params,
    });
  },
  //重新上账
  reUp(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/record/re-up",
      data: params,
    });
  },
};
